import { render, staticRenderFns } from "./ModalAddShift.vue?vue&type=template&id=45b7dcdc&scoped=true&"
import script from "./ModalAddShift.vue?vue&type=script&lang=js&"
export * from "./ModalAddShift.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddShift.vue?vue&type=style&index=0&id=45b7dcdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7dcdc",
  null
  
)

export default component.exports